import type { Game, GameGround, ClubInfo } from '~/types/types';

// Helper to check if ground is an object (new format) or string (legacy)
export function isGroundObject(ground: Game['ground']): ground is GameGround {
   return ground !== null && typeof ground === 'object' && 'name' in ground;
}

// Get display name for ground field
export function getGroundName(ground: Game['ground']): string {
   if (!ground) return '-';
   if (isGroundObject(ground)) return ground.name;
   return ground;
}

// Get Google Maps URL for ground
export function getGroundDirectionsUrl(ground: Game['ground']): string | null {
   if (!ground || !isGroundObject(ground)) return null;
   return ground.directions_url || null;
}

// Helper to check if club is an object (new format) or string (legacy)
export function isClubObject(club: Game['club']): club is ClubInfo {
   return club !== null && typeof club === 'object' && 'name' in club;
}

// Get display name for club field
export function getClubName(club: Game['club']): string {
   if (!club) return '-';
   if (isClubObject(club)) return club.name;
   return club;
}

// Get Google Maps URL for club
export function getClubDirectionsUrl(club: Game['club']): string | null {
   if (!club || !isClubObject(club)) return null;
   return club.directions_url || null;
}
